import axiosInstance from "../utils/AxiosInstance";
import { getAuthToken } from "../utils/commonHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/contact-us`; // Replace with your actual API URL

export const fetchContactUsTable = async (page: number, limit: number) => {
  const customHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
  const response = await axiosInstance.get(
    `${API_URL}/table?page=${page}&limit=${limit}`,
    { headers: customHeaders }
  );
  return response.data;
};

export const sendReplyQuery = async ({
  message,
  id,
}: {
  message: string;
  id: string;
}) => {
  const customHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${getAuthToken()}`,
  };
  const response = await axiosInstance.post(
    `${API_URL}/reply/${id}`,
    {  message },
    { headers: customHeaders }
  );
  return response.data;
};
